import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { Community } from "../../../../models";

@Component({
  selector: "del-community-auth-modal",
  templateUrl: "./del-community-auth-modal.component.html",
  styleUrls: [
    "./del-community-auth-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DelCommunityAuthModal implements OnInit {
  @Input() community: Community;
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
